import type { InputProps } from 'antd'
import { CancelLineIcon } from './Icons'
import TextInput from './TextInput'

interface Props {
  touched?: (boolean | undefined)[]
  disabled: boolean
  errors?: (string | undefined)[]
  initialValues: string[]
  values: string[]
  label: string
  placeholder: string
  onBlur: React.FocusEventHandler<HTMLInputElement>
  setFieldValue: (field: string, values: string | string[]) => void
  inputProps: InputProps
}

const MultiLinesInput = ({
  touched,
  values,
  initialValues,
  errors,
  disabled,
  onBlur,
  setFieldValue,
  label,
  placeholder,
  inputProps,
}: Props) => (
  <>
    {values.map((line, index) => (
      <TextInput
        key={line.replaceAll(' ', '-')}
        error={errors?.[index]}
        touched={!!touched?.[index] && initialValues[index] !== values[index]}
        label={index === 0 ? label : ''}
        inputProps={{
          ...inputProps,
          onBlur,
          disabled,
          autoFocus: true,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            setFieldValue(`lines.${index}`, e.target.value),
          name: `lines.${index}`,
          value: line || '',
          placeholder,
        }}
      >
        {index !== 0 && (
          <button
            type="button"
            disabled={disabled}
            style={{
              background: 'none',
              border: 'none',
              cursor: disabled ? 'not-allowed' : 'pointer',
              lineHeight: 0,
              padding: 0,
              position: 'absolute',
              right: '-35px',
              top: '-3px',
            }}
            onClick={() =>
              setFieldValue(
                'lines',
                values.filter((_v, i) => i !== index)
              )
            }
          >
            <CancelLineIcon />
          </button>
        )}
      </TextInput>
    ))}
  </>
)

export default MultiLinesInput
